module.exports = __webpack_public_path__ + "static/media/payment-method-icon.888bc57e.svg";